import { render, staticRenderFns } from "./MultiColorLabel.vue?vue&type=template&id=24a3d209&scoped=true&"
import script from "./MultiColorLabel.vue?vue&type=script&lang=js&"
export * from "./MultiColorLabel.vue?vue&type=script&lang=js&"
import style0 from "./MultiColorLabel.vue?vue&type=style&index=0&id=24a3d209&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a3d209",
  null
  
)

export default component.exports